export const formatHeat = (value: number): string => {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return value.toLocaleString('zh-CN');
};

export const statusStyle: Record<string, string> = {
  持续发酵: 'bg-accent-500 text-background-50',
  已平息: 'bg-secondary-500 text-background-50',
  出现反转: 'bg-primary-500 text-foreground-950',
};